var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_655_4052",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_655_4052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 1H21V3.88462C21 4.22824 20.8094 4.54566 20.5 4.71736C20.1906 4.88907 19.8094 4.88907 19.5 4.71736C19.1906 4.54566 19 4.22822 19 3.88462V1H15V3.88462C15 4.22824 14.8094 4.54566 14.5 4.71736C14.1906 4.88907 13.8094 4.88907 13.5 4.71736C13.1906 4.54566 13 4.22822 13 3.88462V1H9V3.88462C9 4.22824 8.80938 4.54566 8.5 4.71736C8.19062 4.88907 7.80937 4.88907 7.5 4.71736C7.19063 4.54566 7 4.22822 7 3.88462V1H6C5.20423 1 4.44131 1.30391 3.87857 1.84478C3.31607 2.38586 3 3.11945 3 3.88462V23.1154C3 23.8805 3.31607 24.6141 3.87857 25.1552C4.4413 25.6961 5.20423 26 6 26H22C22.7958 26 23.5587 25.6961 24.1214 25.1552C24.6839 24.6141 25 23.8805 25 23.1154V3.88462C25 3.11945 24.6839 2.38588 24.1214 1.84478C23.5587 1.30391 22.7958 1 22 1ZM14 19.2692H8C7.64263 19.2692 7.31251 19.0859 7.13394 18.7885C6.95537 18.491 6.95537 18.1244 7.13394 17.8269C7.31251 17.5294 7.64265 17.3462 8 17.3462H14C14.3574 17.3462 14.6875 17.5294 14.8661 17.8269C15.0446 18.1244 15.0446 18.491 14.8661 18.7885C14.6875 19.0859 14.3574 19.2692 14 19.2692ZM20 15.4231H8C7.64263 15.4231 7.31251 15.2398 7.13394 14.9423C6.95537 14.6448 6.95537 14.2782 7.13394 13.9808C7.31251 13.6833 7.64265 13.5 8 13.5H20C20.3574 13.5 20.6875 13.6833 20.8661 13.9808C21.0446 14.2782 21.0446 14.6448 20.8661 14.9423C20.6875 15.2398 20.3574 15.4231 20 15.4231ZM20 11.5769H8C7.64263 11.5769 7.31251 11.3936 7.13394 11.0962C6.95537 10.7987 6.95537 10.4321 7.13394 10.1346C7.31251 9.83714 7.64265 9.65385 8 9.65385H20C20.3574 9.65385 20.6875 9.83714 20.8661 10.1346C21.0446 10.4321 21.0446 10.7987 20.8661 11.0962C20.6875 11.3936 20.3574 11.5769 20 11.5769Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClient);
export default __webpack_public_path__ + "static/media/iconClient.bfbd846859275c65214db462562e1007.svg";
export { ForwardRef as ReactComponent };